import { attributeRoutes } from '../modules/attribute/routes';

export const phaRoutes = [
    {
        path: 'attribute',
        children: attributeRoutes,
    },
];
